<template>
  <div class="container">
    <div class="ap_main">
      <iframe
        id="iframeBox"
        name="iframeBox"
        seamless
        scrolling="no"
        src="https://smbcloud.tp-link.com.cn/login.html"
      >
        您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面
     </iframe>
    </div>
  </div>
</template>
<script>
// src="https://smbcloud.tp-link.com.cn/nms/#/networkState/netSituation?projectId=537661418229637120"
export default {
  data () {
    return {
      title: '',
      baseUrl:''
    }
  }
}
</script>
<style scoped>
.container {
  position: relative;
	width: 100%;
	height:100%;
	background:url('../../assets/datacount.png') no-repeat;
	background-size: cover;
}
.ap_main{
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  overflow: hidden;
}

#iframeBox{
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin:0;
}
</style>